import { NextSeo } from 'next-seo';
import React from 'react';
import Button from '../../components/Button';
import FlipsInfo from '../../components/FlipsInfo';
import PageHeader from '../../components/PageHeader';
import TheFlipsStatsPage from '../../components/TheFlipsStatsPage';
import config from '../../config';

function FlipsStatsPage() {
  const title = `Shitty Flips Stats - ${config.siteName}`;

  return (
    <>
      <NextSeo title={title} />

      <div className='pb-12 md:pb-48 bg-bg'>
        <PageHeader heading={'Shitty Flips Stats'} />

        <div className='flex justify-center mt-6'>
          <Button link href='/flips' theme='outline'>
            Back to Flips
          </Button>
        </div>

        <div className='px-4 max-w-[85rem] lg:mx-auto lg:px-8'>
          <TheFlipsStatsPage />
          <FlipsInfo />
        </div>
      </div>
    </>
  );
}

export default FlipsStatsPage;
